import React from "react";
import css from "./Hero.module.css";
import HeroImg from "../../assets/hero.png";
import { RiShoppingBagFill } from "react-icons/ri";
import { BsArrowRight } from "react-icons/bs";
import { motion } from "framer-motion";
const hero = () => {
  const transition = { duration: 3, type: "spring" };
  return (
    <div className={css.container}>
      <div className={css.h_sides}>
        <span className={css.text1}>Skin Protectioon cream</span>

        <div className={css.text2}>
          <span>Trendy collection</span>
          <span> Lorem ipsum dolor sit amet citi aspernatur quam in</span>
        </div>
      </div>

      <div className={css.wrapper}>
        <div
          intial={{ bottom: "0" }}
          whileInView={{ bottom: "2rem" }}
          className={css.bulecircle}
          transition={transition}
        ></div>
        <motion.img
          transition={transition}
          intial={{ bottom: "-4rem" }}
          whileInView={{ bottom: "0px" }}
          src={HeroImg}
          alt=""
          width={600}
        />
        <motion.div
        intial={{ right:"2rem" }}
        whileInView={{ right:"2px" }}
        transition={transition}
         className={css.cart2}>
          <RiShoppingBagFill />

          <div className={css.signup}>
            <span>Best Signup Offers</span>

            <div>
              <BsArrowRight />
            </div>
          </div>
        </motion.div>
      </div>

      <div className={css.h_sides}>
        <div className={css.traffic}>
          <span>1.5m</span>
          <span>Monthly traffic</span>
        </div>

        <div className={css.customers}>
          <span>100k</span>
          <span>Happy customers</span>
        </div>
      </div>
    </div>
  );
};

export default hero;
